import React, { Fragment } from "react";

type Props = {
  loading: boolean;
};

const Loading: React.FC<Props> = ({ loading }): JSX.Element => {
  return (
    <Fragment>
      {loading && (
        <div className="fixed z-30 inset-0 bg-bt-dark-gray-transparent bg-opacity-50 w-full h-full">
          <div className="flex flex-row h-full">
            <div className="relative my-auto mx-auto">
              <div
                style={{ borderTopColor: "transparent" }}
                className="w-10 h-10 border-4 border-bt-white border-solid rounded-full animate-spin"
              />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Loading;
